<template>
  <div class="menu-container">
    <el-row class="menu-wrapper">
      <el-col :span="24">
        <el-menu
          :default-active="$route.path"
          active-text-color="#ffffff"
          :collapse="false"
          class="menu-vertical"
          @open="handleOpen"
          @close="handleClose"
          :default-openeds="openeds"
          router
          background-color="#ffffff"
          text-color="#495057">

          <!-- 基本操作子菜单 -->
          <el-submenu index="1" class="menu-submenu">
          <!--  <template slot="title">
              <i class="el-icon-s-operation menu-icon"></i>
              <span class="menu-title">基本操作</span>
            </template> -->

            <!-- 手工导入Excel -->
            <el-tooltip
              class="menu-item-tooltip"
              effect="dark"
              content="导入现有的excel表格文件,制作手机端填写表格"
              placement="right">
              <el-menu-item index="/import_data_excel" class="menu-item">
                <i class="el-icon-upload2 item-icon"></i>
                <span slot="title" class="item-title">手工导入(手工匹配)</span>
              </el-menu-item>
            </el-tooltip>

            <!-- 智能导入Excel -->
            <el-tooltip
              class="menu-item-tooltip"
              effect="dark"
              content="导入现有的excel表格文件,制作手机端填写表格"
              placement="right">
              <el-menu-item index="/import_data_excel_ai" class="menu-item">
                <i class="el-icon-magic-stick item-icon"></i>
                <span slot="title" class="item-title">智能导入(自动匹配)</span>
              </el-menu-item>
            </el-tooltip>

            <!-- 管理所有查询 -->
            <el-tooltip
              class="menu-item-tooltip"
              effect="dark"
              content="管理我发出去的表格"
              placement="right">
              <el-menu-item index="/query_list" class="menu-item">
                <i class="el-icon-s-management item-icon"></i>
                <span slot="title" class="item-title">管理所有查询</span>
              </el-menu-item>
            </el-tooltip>

          </el-submenu>
        </el-menu>
      </el-col>
    </el-row>

    <!-- 菜单底部装饰 -->
<!--    <el-row class="menu-footer">
      <el-col :span="24">
        <div class="footer-content">
          <div class="footer-divider"></div>
          <div class="footer-text">
            <i class="el-icon-s-custom footer-icon"></i>
            <span>{{username || '用户'}}</span>
          </div>
        </div>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
export default {
  name: 'MenuList',
  data: function() {
    return {
      openeds: ['1', '2', '3', '4', '5'],
      username: '',
      activeIndex: '',

      invited_count: 0,
      myform_count: 0
    }
  },
  created() {
    this.username = this.$session.get('USERNAME') // 获取session
    this.setCurrentRoute()
    this.loadMenuNum()
  },
  // 检测路由变化
  watch: {
    $route() {
      this.setCurrentRoute()
    }
  },
  methods: {
    setCurrentRoute() {
      this.activeIndex = this.$route.path // 通过他就可以监听到当前路由状态并激活当前菜单
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)

      //
      if (key === '1-0') {
        this.active_key = '1-0'
        this.$router.push('/table_view')
      } else if (key === '1-1') {
        this.active_key = '1-1'
        this.$router.push('/make_form')
      } else if (key === '1-3') {
        this.active_key = '1-3'
        this.$router.push('/form_list')
      } else if (key === '1-2') {
        this.active_key = '1-2'
        this.$router.push('/import_excel')
      } else if (key === '1-4') {
        this.active_key = '1-4'
        this.$router.push('/read_me')
      }
    },
    helpShow() {
      console.log('用户名' + this.username)
      if (this.username === 'admin') {
        return true
      } else {
        return false
      }
    },
    loadMenuNum() {
      console.log('加载数据')
      let that = this

      // 开启loading
      /*         const load = this.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                }) */

      // var requestUrl = '/form/web/_load_menu_info.jsp'
      // this.axios.get(requestUrl, {
      //     params: {
      //       username: that.username
      //     }
      //   }).then(function(response) {
      //     // load.close()
      //     that.invited_count = response.data.invited_count
      //     that.myform_count = response.data.myform_count
      //   })
      //   .catch(function(error) {
      //     console.log(error)
      //     // load.close()
      //   })
    }
  }
}
</script>

<style scoped>
/* ==================== 菜单容器 ==================== */
.menu-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.06);
}

.menu-wrapper {
  flex: 1;
  overflow-y: auto;
}

/* ==================== 主菜单样式 ==================== */
.menu-vertical {
  border-right: 1px solid #f0f0f0;
  background: transparent !important;
}

/* 子菜单样式 */
.menu-submenu >>> .el-submenu__title {
  height: 50px;
  line-height: 50px;
  padding: 0 20px !important;
  color: #2c3e50 !important;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #f8f9fa;
  transition: all 0.3s ease;
}

.menu-submenu >>> .el-submenu__title:hover {
  background: #f8f9fa !important;
  color: #667eea !important;
}

.menu-submenu >>> .el-submenu__title i {
  color: #667eea;
  font-size: 18px;
  margin-right: 10px;
  transition: all 0.3s ease;
}

.menu-submenu >>> .el-submenu__title:hover i {
  transform: scale(1.1);
  color: #667eea;
}

/* 箭头图标 */
.menu-submenu >>> .el-submenu__title .el-submenu__icon-arrow {
  color: #7f8c8d;
  font-size: 12px;
  transition: all 0.3s ease;
}

.menu-submenu >>> .el-submenu__title:hover .el-submenu__icon-arrow {
  color: #667eea;
}

/* 菜单标题 */
.menu-title {
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* 菜单图标 */
.menu-icon {
  color: #667eea;
  font-size: 18px;
  margin-right: 10px;
  transition: all 0.3s ease;
}

.menu-submenu:hover .menu-icon {
  color: #667eea;
  transform: scale(1.1);
}

/* ==================== 子菜单项样式 ==================== */
.menu-submenu >>> .el-menu {
  background: #f8f9fa !important;
}

.menu-item {
  height: 45px;
  line-height: 45px;
  padding: 0 12px 0 20px !important;
  margin: 4px 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
  color: #6c757d !important;
  font-size: 13px;
}

.menu-item:hover {
  background: #667eea !important;
  color: #ffffff !important;
  transform: translateX(4px);
}

.menu-item.is-active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  font-weight: 500;
}

/* 菜单项图标 */
.item-icon {
  font-size: 14px;
  margin-right: 8px;
  color: #95a5a6;
  transition: all 0.3s ease;
}

.menu-item:hover .item-icon {
  color: #ffffff;
  transform: scale(1.2);
}

.menu-item.is-active .item-icon {
  color: #ffffff;
}

/* 菜单项标题 */
.item-title {
  font-size: 13px;
  transition: all 0.3s ease;
}

.menu-item:hover .item-title {
  color: #ffffff;
}

/* ==================== Tooltip 样式 ==================== */
.menu-item-tooltip {
  width: 100%;
}

/* ==================== 菜单底部 ==================== */
.menu-footer {
  background: #ffffff;
  border-top: 1px solid #f0f0f0;
}

.footer-content {
  padding: 15px 20px;
}

.footer-divider {
  height: 1px;
  background: linear-gradient(90deg,
    transparent 0%,
    rgba(0, 0, 0, 0.06) 50%,
    transparent 100%);
  margin-bottom: 12px;
}

.footer-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #6c757d;
  font-size: 12px;
  padding: 8px;
  border-radius: 6px;
  background: #f8f9fa;
  transition: all 0.3s ease;
}

.footer-text:hover {
  background: #667eea;
  color: #ffffff;
}

.footer-icon {
  font-size: 14px;
  color: #667eea;
}

.footer-text:hover .footer-icon {
  color: #ffffff;
}

/* ==================== 滚动条样式 ==================== */
.menu-wrapper::-webkit-scrollbar {
  width: 6px;
}

.menu-wrapper::-webkit-scrollbar-track {
  background: #f8f9fa;
  border-radius: 3px;
}

.menu-wrapper::-webkit-scrollbar-thumb {
  background: #dee2e6;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.menu-wrapper::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}

/* ==================== 响应式设计 ==================== */
@media (max-width: 768px) {
  .menu-container {
    height: auto;
    min-height: 100vh;
  }

  .menu-submenu >>> .el-submenu__title {
    height: 45px;
    line-height: 45px;
    padding: 0 15px !important;
    font-size: 13px;
  }

  .menu-item {
    height: 40px;
    line-height: 40px;
    padding: 0 10px 0 18px !important;
    margin: 3px 8px;
    font-size: 12px;
  }

  .item-icon {
    font-size: 13px;
    margin-right: 6px;
  }

  .footer-text {
    font-size: 11px;
    padding: 6px;
  }
}

@media (max-width: 480px) {
  .menu-submenu >>> .el-submenu__title {
    height: 40px;
    line-height: 40px;
    padding: 0 12px !important;
    font-size: 12px;
  }

  .menu-icon,
  .menu-submenu >>> .el-submenu__title i {
    font-size: 16px;
    margin-right: 8px;
  }

  .menu-item {
    height: 38px;
    line-height: 38px;
    padding: 0 8px 0 16px !important;
    margin: 2px 6px;
    font-size: 11px;
  }

  .item-icon {
    font-size: 12px;
    margin-right: 5px;
  }

  .footer-content {
    padding: 12px 15px;
  }

  .footer-text {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menu.vue